<template>
    <div class="col-md-12">
        <pim-header
            :can-create="true"
            :create-url="createExportProfileUrl"
            create-button-text="Create Import Export Profile"
            header="Profiles"
        ></pim-header>
        <transition name="vue-table-loader">
            <div class="vue-table-loader" v-if="loading">
                <span class="fa fa-cog fa-spin fa-3x"></span>
            </div>
        </transition>
        <div class="row">
            <div class="col-md-4">
                <base-filter-bar :placeholder="`Search Profiles`"></base-filter-bar>
            </div>
            <div class="col-md-8">
                <base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
            </div>
        </div>
        <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
            <vuetable ref="vuetable"
                :api-url="gridUrl"
                :fields="fields"
                :css="css.table"
                :per-page="perPage"
                :sort-order="sortOrder"
                :append-params="moreParams"
                noDataTemplate="No Export Profiles Found"
                pagination-path=""
                @vuetable:pagination-data="onPaginationData"
                @vuetable:loaded="onLoaded"
            >
                <template slot="name" slot-scope="props">
                    <a :href="editUrl(props.rowData.id)">{{props.rowData.name}}</a>
                </template>
                <template slot="actions" slot-scope="props">
                    <div class="d-flex">
                        <button class="btn btn-outline-primary mr-2" @click="startExport(props.rowData.id)">Export</button>
                        <a class="btn btn-outline-primary mr-2" :href="importTypeUrl(props.rowData.id)">Import</a>
                        <form class="d-flex" style="align-items: flex-end;" :action="deleteUrl(props.rowData.id)" method="post">
                            <input type="hidden" name="_token" :value="csrfToken">
                            <input type="hidden" name="_method" value="DELETE">
                            <input type="hidden" name="id" :value="props.rowData.id">
                            <div class="dropdown export-tool-menu text-right"  style="margin-left:5px;">
                                <button type="button" class="btn btn-outline-primary " data-toggle="dropdown">
                                    <i class="fa fa-cog" aria-hidden="true"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                                    <a class="dropdown-item" :href="editUrl(props.rowData.id)">Edit</a>
                                    <input type="submit" class="dropdown-item" value="Delete">
                                </div>
                            </div>
                        </form>
                    </div>
                </template>
            </vuetable>
            <div class="row">
                <div class="col-md-6">
                    <base-pagination-info
                        :css="css.table"
                        ref="paginationInfo"
                    >
                    </base-pagination-info>
                </div>
                <div class="col-md-6">
                    <base-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                    ></base-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import BaseFilterBar from '../tables/base-filter-bar.vue';
    import BasePagination from '../tables/base-pagination.vue';
    import BasePaginationInfo from '../tables/base-pagination-info.vue';
    import BaseSelectVisible from '../tables/base-select-visible.vue';
    import PimHeader from '../generic/pim-header';

    export default {
        name: 'export-profiles-index',
        components: {
            'base-filter-bar': BaseFilterBar,
            'base-pagination': BasePagination,
            'base-pagination-info': BasePaginationInfo,
            'base-select-visible': BaseSelectVisible,
            'pim-header': PimHeader,
        },
        props: ['csrfToken'],
        data() {
            return {
                fields: [
                    {
                        name: '__slot:name',
                        title: 'Name',
                        sortField: 'name',
                    },
                    // {
                    //     name: 'config',
                    //     title: 'Config',
                    // },
                    {
                        name: '__slot:actions',
                        titleClass: 'actions-single-column',
                    },
                ],
                perPage: 10,
                moreParams: {},
                sortOrder: [
                    {
                        field: 'name',
                        direction: 'asc',
                    }
                ],
                loading: true,
                amountsShown: [
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 }
                ],
                css: {
                    table: {
                        tableClass: 'table table-striped table-bordered table-middle',
                        ascendingIcon: 'sort-icon-asc',
                        descendingIcon: 'sort-icon-desc',
                        infoClass: '',
                    },
                },
            }
        },
        methods: {
            startExport(exportId) {
                axios.post('/exports/start', {
                    'id': exportId,
                })
                    .then((response) => {
                        window.location.href = '/exports';
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            },
            deleteProfile(id) {
                return axios.delete(route('export-profiles.destroy', id))
                    .then((response) => {
                        window.location.href = '/exports';
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            importTypeUrl(id) {
                return route('imports.form', id);
            },
            editUrl(id){
                return route('export-profiles.edit', id);
            },
            deleteUrl(id) {
                return route('export-profiles.destroy', id);
            },
        },
        computed: {
            createExportProfileUrl() {
                return route('export-profiles.create');
            },
            gridUrl() {
                return '/export-profiles/grid';
            },
        },
        mounted() {
            this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
            this.$events.$on('filter-reset', e => this.onFilterReset())
        },
        watch: {
            perPage() {
                this.$nextTick(function() {
                    this.$refs.vuetable.refresh()
                })
            },
        },
    }
</script>

<style scoped>
    .export-tool-menu .btn{
        padding: 10px 15px;
    }
</style>
